import React from "react";
import styles from "./AppMenuSection.module.css";

export default function AppMenuSection({
  title = "",
  children,
  className = "",
}) {
  return (
    <div className={[styles.section, className].join(" ")}>
      {title ? <div className={styles.title}>{title}</div> : null}
      <div className={styles.content}>{children}</div>
    </div>
  );
}